
export default function hr_meetings( state = [], action = {} ){

	switch( action.type ){
		case 'GET_MEETING_REPORTS':
			return action.hr_meetings
		case 'UPDATE_MEETING_FIELDS':
			return action.hr_meetings
		case 'GET_INITIAL_USERS':
			return action.hr_meetings
		case 'HR_DELETE_MEETING':
			return action.hr_meetings
		default: return state;
	}``
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/hr_reports/hr_reports.reducer.js